/**
 * api/hseFeedbackApi.js — ЕРӨНХИЙ ХАБЭА-Н САНАЛ, ГОМДОЛ.
 *
 * Backend: Flask/Resources/XAB/hse_feedback.py
 * Журам:   ХЭМАБМТ-08 4.1.3 (ажилтны санал өгөх ЭРХ) · 4.6.1 (урамшуулал) ·
 *          6.6.1.2 / 6.6.2.2 (үзүүлэлт) · ХЭМАБМТ-14 1.4.10 (шударга бүртгэл)
 *
 * УРСГАЛ: new → reviewed → assigned → resolved → closed (эсвэл rejected)
 *
 * ⚠ ХООЛНЫ `hygieneApi`-ТАЙ ХОЛИХГҮЙ. Тэр нь `/xab/meal-feedback`
 *   (хоолны газар, хоол үйлдвэрлэгч); энэ нь `/xab/hse-feedback` —
 *   дотоод нэгж рүү хуваарилагддаг ерөнхий ХАБЭА-н суваг. Хоёр модулийн
 *   тайлан ба дугаарлалт (`SG-` ба `SGH-`) ТУСДАА.
 */
import api from "src/api/xabApi";

export const hseFeedbackApi = {
  /**
   * params: status · kind · category_id · tseh_code · from · to ·
   *         mine=1 (миний бичсэн) · assigned=1 (надад хуваарилсан) ·
   *         overdue=1
   */
  list: (params = {}) =>
    api.get("/xab/hse-feedback", { params }).then((r) => r.data),
  get: (id) => api.get(`/xab/hse-feedback/${id}`).then((r) => r.data),
  create: (body) => api.post("/xab/hse-feedback", body).then((r) => r.data),
  /** ХООЛНЫ ЛАВЛАХУУД — нэгдсэн маягтын «Халуун хоол» төрөлд.
      ⚠ Байршил ба хоол үйлдвэрлэгч нь ХУУЧИН хүснэгтэд үлдсэн
        (`xab.meal_location`, `xab.meal_provider`): тэд нь гомдлын
        хүснэгттэй хамааралгүй, өөрөө лавлах тул хөдөлгөөгүй. */
  mealLocations: () =>
    api.get("/xab/meal-locations").then((r) => r.data),
  mealProviders: () =>
    api.get("/xab/meal-providers").then((r) => r.data),

  /** action: review | assign | act | resolve | close | reject | reward
      ⚠ `assign` нь `provider_id` ирвэл ГАДНЫ хоол үйлдвэрлэгч рүү
        шилжүүлнэ (хуучин хоолны `transfer`), `assigned_tseh_code`/
        `assigned_tn` ирвэл дотоод нэгж рүү. Төлөв нь хоёуланд ижил.
      ⚠ `act` нь ЗӨВХӨН хоолны гомдолд бөгөөд ТӨЛӨВ хөдөлгөхгүй. */
  act: (id, action, body = {}) =>
    api.post(`/xab/hse-feedback/${id}/${action}`, body).then((r) => r.data),

  /** group: month | quarter | year — ЗӨВХӨН ХАБЭА хэлтэст (403) */
  report: (params = {}) =>
    api.get("/xab/hse-feedback/report", { params }).then((r) => r.data),

  /* ── Чиглэлийн лавлах ──
     ⚠ `topic` (2026-10-04): 'general' | 'meal'. Заагаагүй бол ХОЁУЛАНГ
       буцаана — /feedback-ийн лавлахын хуудас бүгдийг удирддаг. Харин
       БҮРТГЭХ маягт нь ЗААВАЛ topic заана, эс бөгөөс ажилтан хоолны
       гомдолдоо «Галын аюулгүй байдал» гэж сонгож чадна. */
  categories: (all = false, topic) =>
    api
      .get("/xab/hse-feedback-categories", {
        params: {
          ...(all ? { all: 1 } : {}),
          ...(topic ? { topic } : {}),
        },
      })
      .then((r) => r.data),
  saveCategory: (body) =>
    api.put("/xab/hse-feedback-categories", body).then((r) => r.data),
  removeCategory: (id) =>
    api
      .delete("/xab/hse-feedback-categories", { params: { id } })
      .then((r) => r.data),
};

/**
 * Төлөв — шошго + өнгө НЭГ эх сурвалжаас.
 *
 * ⚠ Дарааллыг УРСГАЛЫН дарааллаар бичив (new → … → closed): шүүлтийн
 *   Select нь объектын дарааллаар харагддаг тул цагаан толгойн дараалал
 *   болговол хэрэглэгч урсгалыг уншиж чадахгүй.
 * ⚠ `status_label`-ыг backend ч буцаадаг. Жагсаалтад серверийнхийг
 *   хэрэглэнэ; энэ нь ШҮҮЛТ, ӨНГӨ-нд (сервер өнгө буцаадаггүй).
 */
export const FB_STATUS = {
  new: { label: "Шинэ", color: "#0D7FD6", bg: "#E4F0FB" },
  reviewed: { label: "Хүлээн авсан", color: "#5B3FD1", bg: "#EDE9FB" },
  assigned: { label: "Хуваарилсан", color: "#A8560A", bg: "#FBEEDF" },
  resolved: { label: "Хэрэгжүүлсэн", color: "#157F45", bg: "#E4F4EA" },
  closed: { label: "Хаасан", color: "#4A5568", bg: "#EDEFF3" },
  rejected: { label: "Үндэслэлгүй", color: "#8A94A6", bg: "#F1F3F6" },
};

/** Хийгдээгүй гэж тооцогдох төлвүүд — backend-ийн PENDING-тэй ИЖИЛ.
 *  ⚠ `resolved` ОРОХГҮЙ: хэрэгжүүлсэн атал ХАБЭАХ хаагаагүй нь нэгжийн
 *    биш, хэлтсийн хоцрогдол (Models/hse_feedback.py-ийн тайлбарыг үз). */
export const FB_PENDING = ["new", "reviewed", "assigned"];

/** Төлөвийн өнгө — жагсаалт, badge, тайланд НЭГ эх сурвалжаас. */
export const FB_STATUS_COLOR = {
  new: "#0D7FD6",
  reviewed: "#7A5AF8",
  assigned: "#D6730A",
  resolved: "#1F9D55",
  closed: "#5A6478",
  rejected: "#A8AFBC",
};

/** Төрлийн icon — санал/гомдол/хүсэлт нь нүдээр шууд ялгарна. */
export const FB_KIND_META = {
  suggestion: { icon: "fa-lightbulb", color: "#1F9D55", label: "Санал" },
  complaint: { icon: "fa-exclamation-circle", color: "#E5484D", label: "Гомдол" },
  question: { icon: "fa-question-circle", color: "#0D7FD6", label: "Хүсэлт, асуулт" },
};

export default hseFeedbackApi;
